module.exports = __webpack_public_path__ + "img/redhat.ba57b51f.svg";